export { default as CustomiseMenuDumb } from './customise-menu-dumb';
